import React, { useState, Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { myProfileService } from '@app/services';
import { setExceptionHandler } from '@app/store/actions';
import { loginForms } from '@app/enums';
import { TwoFactorList } from '@app/modules/mfaToken/components';
import { OtpTest, PushTest, U2fTest } from './components';

function getComponent(
    providers: string[],
    loginForm: loginForms | null,
    setLoginForm: Dispatch<loginForms>
) {
    const isMultipleProviders = providers.length > 1;
    switch (loginForm) {
        case loginForms.twoFactorList:
            return <TwoFactorList setLoginForm={setLoginForm} providers={providers} />;

        case loginForms.twoFactorOtp:
            return <OtpTest setLoginForm={setLoginForm} providers={providers} />;

        case loginForms.twoFactorPush:
            return (
                <PushTest setLoginForm={setLoginForm} isMultipleProviders={isMultipleProviders} />
            );

        case loginForms.twoFactorU2F:
            return (
                <U2fTest isMultipleProviders={isMultipleProviders} setLoginForm={setLoginForm} />
            );

        default:
            return null;
    }
}

export default function TestMfa() {
    const [providers, setProviders] = useState<string[]>([]);
    const [loginForm, setLoginForm] = useState<loginForms | null>(null);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        myProfileService.getProviders().then(({ data }) => {
            setProviders(data.providers);

            if (data.providers.length > 1) {
                setLoginForm(loginForms.twoFactorList);
                return;
            }
            switch (data.providers[0]) {
                case 'otp':
                    setLoginForm(loginForms.twoFactorOtp);
                    break;
                case 'push':
                    setLoginForm(loginForms.twoFactorPush);
                    break;
                case 'u2f':
                    setLoginForm(loginForms.twoFactorU2F);
                    break;

                default:
                    break;
            }
        });
    }, []);

    return (
        <div className='test-mfa'>
            <div className='login__wrapper'>
                <div className='login__container'>
                    {getComponent(providers, loginForm, setLoginForm)}
                </div>
            </div>
        </div>
    );
}
